import type { User } from '@/types'

/** Setores com módulo Gestores (exclui Comercial e Financeiro). */
export const GESTOR_OPERATIONAL_SETORES = [
  'MARKETING',
  'SUPORTE',
  'PROJETOS',
  'CRIACAO',
  'INOVACAO',
  'ADMINISTRATIVO',
] as const

export function canAccessGestoresModule(user: Pick<User, 'role' | 'setor'> | null): boolean {
  if (!user) return false
  if (user.role === 'admin') return true
  if (user.role === 'financeiro') return false
  if (user.role !== 'manager') return false
  if (user.setor === 'COMERCIAL') return false
  return GESTOR_OPERATIONAL_SETORES.includes(
    (user.setor ?? '') as (typeof GESTOR_OPERATIONAL_SETORES)[number],
  )
}

export const GESTOR_SETOR_LABELS: Record<string, string> = {
  MARKETING: 'Marketing',
  SUPORTE: 'Suporte',
  PROJETOS: 'Projetos',
  CRIACAO: 'Criação',
  INOVACAO: 'Inovação',
  ADMINISTRATIVO: 'Administrativo',
}

/** Dashboard eKyte — gestores de Marketing e admin. */
export function canAccessGestorMarketingDashboard(
  user: Pick<User, 'role' | 'setor'> | null,
): boolean {
  if (!user || !canAccessGestoresModule(user)) return false
  if (user.role === 'admin') return true
  return user.role === 'manager' && user.setor === 'MARKETING'
}
